module.exports = __webpack_public_path__ + "static/media/flight.87b7838a.png";